import { qs } from '../utils/dom.js';

/**
 * Status bar — cursor position, zoom, active layer, dirty indicator.
 */
export class StatusBar {
  constructor(state) {
    this.state = state;

    state.onChange('activeLayerIndex', () => this._updateLayer());
    state.onChange('layers', () => this._updateLayer());
    state.onChange('dirty', (dirty) => {
      const el = qs('#status-dirty');
      if (el) el.textContent = dirty ? '\u2022 Modified' : '';
    });
    state.onChange('fileName', () => this._updateTitle());
    state.onChange('dirty', () => this._updateTitle());

    this._updateLayer();
    this._updateTitle();
  }

  _updateLayer() {
    const el = qs('#status-layer');
    const layer = this.state.getActiveLayer();
    if (el && layer) {
      el.textContent = `Layer: ${layer.name}`;
    }
  }

  _updateTitle() {
    const fileName = this.state.get('fileName');
    const dirty = this.state.get('dirty') ? ' *' : '';
    if (fileName) {
      document.title = `${fileName}${dirty} — TileForge Studio`;
    } else {
      document.title = 'TileForge Studio';
    }
  }
}
